import type {
    FC,
    ChangeEventHandler,
    MouseEventHandler,
    ComponentProps,
} from 'react';
import { useCallback } from 'react';

import { Input, Label, StyledIcon } from './styled';

import { IconName } from '../Icon';

type ICheckbox = Omit<ComponentProps<typeof Input>, 'onChange' | 'onClick'> & {
    handleOnChange: (checked: boolean) => void;
    uniqueKey: string | number;
    indetermined?: boolean;
    checked?: boolean; // for controlled checkbox
};

export const Checkbox: FC<ICheckbox> = ({
    handleOnChange,
    uniqueKey,
    disabled,
    indetermined,
    checked,
    ...props
}) => {
    const onChangeHandler: ChangeEventHandler<HTMLInputElement> = useCallback(
        (event) => {
            handleOnChange(event.target.checked);
        },
        [handleOnChange]
    );

    const onClickHandler: MouseEventHandler<
        HTMLLabelElement | HTMLInputElement
    > = useCallback((event) => {
        // We need to stop the event propagation to prevent the Table from being sorted,
        //  when clicking on checkbox in the table head.
        event.stopPropagation();
        // @ts-expect-error
        event.target.focus({ preventScroll: true });
    }, []);

    return (
        <>
            <Input
                type="checkbox"
                id={uniqueKey.toString()}
                name={uniqueKey.toString()}
                onChange={onChangeHandler}
                onClick={onClickHandler}
                indetermined={indetermined}
                checked={checked}
                {...props}
            />
            <Label
                htmlFor={uniqueKey.toString()}
                onClick={onClickHandler}
                disabled={disabled}
            >
                <StyledIcon
                    stroke={indetermined}
                    iconName={
                        indetermined ? IconName.MINUS : IconName.CHECKMARK
                    }
                />
            </Label>
        </>
    );
};

Checkbox.defaultProps = {
    disabled: false,
    indetermined: false,
};
